import { createRouter, createWebHistory } from "vue-router";
import i18n from "@/i18n";

// Layouts
import AppLayout from "@/layouts/game/App.vue";
// Views
// |_ Not authenticated
import AuthView from "@/views/auth/AuthView.vue"
import InvitationView from "@/views/auth/InvitationView.vue";

import ConnectionProblem from "@/views/game/connectionProblem/ConnectionProblemView.vue";
import Maintenance from "@/views/app/errors/Maintenance.vue";
// |_ Transverse
import Instructions from "@/views/game/InstructionsView.vue";
// |_ Authenticated
import Home from "@/views/game/home/HomeView.vue";
import PreGame from "@/views/game/preGame/PreGameView.vue";

import ErrorLayout from "@/layouts/app/Error.vue";
// Navigation guards
import { authGuard } from "@/guards/auth.guard";
import { maintenanceGuard } from "@/guards/maintenance.guard";
import { urlTokenGuard } from "@/guards/url-token.guard";

const { t } = i18n.global;

const gameRouter = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/auth",
      name: "auth",
      component: AuthView,
      meta: {
        layout: AppLayout,
        isPublic: true,
        isTransverse: true,
        document_title: t("app.router.login.documentTitle"),
      },
    },
    {
      path: "/join",
      name: "invitation",
      component: InvitationView,
      meta: {
        layout: AppLayout,
        isPublic: true,
        isTransverse: true,
        document_title: t("app.router.login.documentTitle"),
      },
    },
    {
      path: "/connection-problem",
      name: "game-connection-problem",
      component: ConnectionProblem,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/maintenance",
      name: "game-maintenance",
      component: Maintenance,
      meta: {
        isPublic: true,
        layout: ErrorLayout,
      },
    },
    {
      path: "/instructions",
      name: "game-instructions",
      component: Instructions,
      meta: {
        isPublic: true,
        isTransverse: true,
      },
    },
    // Authenticated
    {
      path: "/",
      name: "game-home",
      component: Home,
    },
    {
      path: "/pre-game",
      name: "game-waiting",
      component: PreGame,
    },
  ],
});

const guards = [urlTokenGuard, maintenanceGuard, authGuard];

gameRouter.beforeEach(async (to, from) => {
  // Run guards
  for (const guard of guards) {
    const result = await guard(to, from)
    if (result) return result;
  }
});

export default gameRouter;
